import Calendar, { WidgetType } from '../models/calendar'

export const getPermanentUrlForCalendar = (
  calendar: Calendar,
  baseUrl: string
) => {
  return `${baseUrl}/widget/booking/${calendar.id}`
}

/** Shared iframe tag for official calendar/group embeds — grants Payment Request / wallets. */
export const buildEmbedIframeTag = (src: string, id: string) => {
  return `<iframe src="${src}" allow="payment" style="width: 100%;border:none;overflow: hidden;" scrolling="no" id="${id}"><\/iframe>`
}

export const getEmbedCodeForCalendar = (
  calendar: Calendar,
  baseUrl: string
) => {
  const embedScript =
    calendar.widgetType === WidgetType.CLASSIC ? 'embed.js' : 'form_embed.js'

  const uniqueId = `${
    calendar.providerId ? calendar.providerId : calendar.id
  }_${new Date().getTime()}`

  const embedBaseUrl = `${baseUrl}/widget/booking/${calendar.id}`

  const calendarId =
    calendar.widgetType === WidgetType.CLASSIC ? 'msgsndr-calendar' : uniqueId

  return `${buildEmbedIframeTag(
    embedBaseUrl,
    calendarId
  )}<br><script src="${baseUrl}/js/${embedScript}" type="text/javascript"><\/script>`
}
